import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';
import {FormField} from 'shells/form/form-field';

type Props = {
    isStopOnRemovedFromAudience: boolean;
    setIsStopOnRemovedFromAudience: (arg1: boolean) => void;
};

export function StopOnRemovedFromAudience(props: Props) {
    return (
        <FormField innerId='stop-on-removed-from-audience'>
            <div style={{marginTop: '16px'}}>
                <Checkbox
                    checked={props.isStopOnRemovedFromAudience}
                    isLarge={true}
                    label='Stop sending when person is removed from audience'
                    onChange={(newValue) => {
                        props.setIsStopOnRemovedFromAudience(newValue);
                    }}
                />
            </div>
        </FormField>
    );
}
